module.exports = __webpack_public_path__ + "static/4-32f8a12de11136a5aa2a6cb40f8f762f.jpg";